import React from "react";
import styled from "styled-components";

const DivCard = styled.div`
width: 45%;
border: solid 1px;
border-top-right-radius: 10px;
border-top-left-radius: 10px;
margin-top: 2rem;
background-color: #f7f7f7;
border-radius: 5px;
@media (min-width: 201px) and (max-width: 500px) {
    width: 90%;
}
`
const DivImg = styled.div`
img {
    width: 100%;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
}
`
const DivTextoImg = styled.div`
display: flex;
margin-top: 1rem;
p {
    font-weight: 700;
}
`

export default class App extends React.Component {
    render() {
        return (
            <DivCard>
                <DivImg>
                    <img src={this.props.imagem} alt="imagem projeto" />
                </DivImg>
                <DivTextoImg>
                    <svg width="20px" height="20px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M16.5264 5.06211C19.1917 7.81864 19.1917 12.2636 16.5264 15.0201L11.7002 20.0001L6.87393 15.0211C4.20869 12.2646 4.20869 7.81964 6.87393 5.06311C8.15004 3.74291 9.88743 3.00019 11.7 3C13.5125 2.99981 15.2501 3.74218 16.5264 5.06211Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M14.4301 9.61108C14.4124 11.153 13.1824 12.3901 11.679 12.378C10.1755 12.3659 8.96452 11.1093 8.97036 9.56721C8.9762 8.02514 10.1966 6.77818 11.7001 6.77808C13.2167 6.78744 14.4388 8.05567 14.4301 9.61108Z" stroke="#000000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
                    </svg>
                    <p>{this.props.local}</p>
                </DivTextoImg>
            </DivCard>
        )
    }
}